/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuthSendResetPassCodeRequestBodyAllOf } from './AuthSendResetPassCodeRequestBodyAllOf';
import {
    AuthSendResetPassCodeRequestBodyAllOfFromJSON,
    AuthSendResetPassCodeRequestBodyAllOfFromJSONTyped,
    AuthSendResetPassCodeRequestBodyAllOfToJSON,
} from './AuthSendResetPassCodeRequestBodyAllOf';

/**
 * 
 * @export
 * @interface AuthSendResetPassCodeRequestBody
 */
export interface AuthSendResetPassCodeRequestBody {
    /**
     * 
     * @type {string}
     * @memberof AuthSendResetPassCodeRequestBody
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthSendResetPassCodeRequestBody
     */
    useExistingCode?: boolean | null;
}

/**
 * Check if a given object implements the AuthSendResetPassCodeRequestBody interface.
 */
export function instanceOfAuthSendResetPassCodeRequestBody(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AuthSendResetPassCodeRequestBodyFromJSON(json: any): AuthSendResetPassCodeRequestBody {
    return AuthSendResetPassCodeRequestBodyFromJSONTyped(json, false);
}

export function AuthSendResetPassCodeRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthSendResetPassCodeRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'useExistingCode': !exists(json, 'useExistingCode') ? undefined : json['useExistingCode'],
    };
}

export function AuthSendResetPassCodeRequestBodyToJSON(value?: AuthSendResetPassCodeRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'useExistingCode': value.useExistingCode,
    };
}

